import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { LoaderService } from '../../sharedServices/loader.service';
import { SharedService } from '../../sharedServices/shared.service';

@Component({
  selector: 'kt-document-handler',
  templateUrl: './document-handler.component.html',
  styleUrls: ['./document-handler.component.scss']
})
export class DocumentHandlerComponent implements OnInit {

  @ViewChild('fileDropRef',{static:false}) fileDropRef: ElementRef;
  private attachmentBase64: string;
  public isImageAlert:boolean = false;
  private fileExt: string = HEC_CONSTANTS.CONSTANT_VALUES.fileExt;
  private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
  public loader: boolean = false;
  public fileUploader:boolean=false;
  files: any[] = [];
  
  constructor(private cdr: ChangeDetectorRef,private ng2ImgMax: Ng2ImgMaxService,
    public _snackBar: MatSnackBar,private loaderService:LoaderService,
    private sharedService:SharedService) { }

  ngOnInit() {
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }


  public fileBrowseHandler(files):void {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  public deleteFile(index: number):void {
    this.files.splice(index, 1);
  }


  private uploadFilesSimulator(index: number):void {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
            this.fileUploader=false;
            this.cdr.detectChanges();
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  private async prepareFilesList(e: Array<any>) {
    if(e.length > 1){
      return false;
    }
    let image = e[0];
    let test:File;  
    let file = e[0];
    if (this.isValidFile(file)) {
      this.fileUploader = true;
    this.cdr.detectChanges();
    if (file.type !== 'application/pdf') {
    this.ng2ImgMax.compressImage(image, 0.575).subscribe(
      async result => {
        test = result;
      await this.setAttachmentsPayload(result);

      },
      error => {
        console.log(error);
        this.fileUploader = false;
        this.cdr.detectChanges();
      }
    );
    }else{
      await this.setAttachmentsPayload(image);
    }
    for (const item of e) {
      item.progress = 0;
      this.files.push(item);
    }
    
    this.uploadFilesSimulator(0);
  }else{
    e=undefined
    file=undefined
    this.fileDropRef.nativeElement.value = null
  }
  }

  private isValidFile(file):boolean {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
    const fileSizeinKB = file.size / 1024;

    if (extensions.indexOf(ext) === -1) {
      this.isImageAlert = true;
      this._snackBar.open('Error in uploading ' + file.name + ' due to invalid file type.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      file=[];
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      return false;
    } else if (!file.name.match()) {
      this.isImageAlert = true;
      file=[];
      this._snackBar.open('Invalid File Name', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      return false;
    } 
    else if (fileSizeinKB > this.maxSize) {
      file=[];
      this.isImageAlert = true
      this._snackBar.open(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', '', {
        duration: 3500,
        panelClass: ['error-snackbar']
      });
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isImageAlert = false;
        this.cdr.detectChanges();
      }, 3000);   
      return false;
    }
    return true;
  }

  private async setAttachmentsPayload(file) {
    // this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  }


}
